import { useState, useEffect } from 'react';
import {
  Button,
  Grid,
  TextField,
  Typography,
  FormControl,
  Select,
  MenuItem,
} from '@mui/material';
import NavigationDrawer from '../../../../components/navigationDrawer';
import restaurantStyle from './style';
import DynamicTable from '../../../../components/dynamicTable';
import moment from 'moment';
import RestaurentDialog from './customersDialog';
import { useNavigate } from 'react-router-dom';
import {
  getAllRestaurants,
  updateRestStatus,
} from './../../../../services/restaurant/index';
import Loader from '../../../../components/loader';
import SnackbarAlert from './../../../../components/snackbar/SnackbarAlert';
import {
  updateCategoryStatus,
  updateCategoryStatusRejected,
} from '../../../../services/categories';
import { DateRangePicker } from 'react-dates';
import { getAllUsers, updateUserStatus } from '../../../../services/users';

const headerData = [
  {
    id: 'profilePicture',
    numeric: false,
    disablePadding: true,
    label: 'Profile Picture',
  },
  {
    id: 'name',
    numeric: false,
    disablePadding: true,
    label: 'Name',
  },
  {
    id: 'userName',
    numeric: false,
    disablePadding: true,
    label: 'Username',
  },
  {
    id: 'email',
    numeric: false,
    disablePadding: true,
    label: 'Email',
  },
  {
    id: 'phoneNumber',
    numeric: true,
    disablePadding: false,
    label: 'Phone Number',
  },
  {
    id: 'gender',
    numeric: true,
    disablePadding: false,
    label: 'Gender',
  },
  {
    id: 'city',
    numeric: true,
    disablePadding: false,
    label: 'City',
  },
  {
    id: 'status',
    numeric: true,
    disablePadding: false,
    label: 'Unblock/Block',
  },
];

const customersData = [
  {
    _id: '630f797fd3c18c2bf3725b5f',
    name: 'Jack',
    email: 'Jack@gmail.com',
    phoneNumber: '123456789111',
    gender: 'Male',
    isApprove: 'Active',
    destination: 'The Maldives',
    age: 22,
    address: '1800 Ellis St, San Francisco, CA 94115, USA',
    logoImage:
      'https://amberstore.pk/uploads/374650464-b0d9a96d-023a-434c-ba2b-50bf59b32584.jpg',
    restuarantImage:
      'https://amberstore.pk/uploads/836126166-63eda87d-8abf-42f3-9f5b-4a106e63dbd8.jpg',
    role: 'Restaurant',
    isFeatured: false,
    category: 'afghani food',
    pickup: true,
    delivery: true,
    latitude: '37.785834',
    longitude: '-122.406417',
    RequestedCategory: '',
  },
  {
    _id: '630f7b6c1a119e58d24e8b66',
    name: 'Ella',
    email: 'Ella@gmail.com',
    gender: 'Female',
    destination: 'Africa on a Safari',
    age: 25,
    phoneNumber: '123456789111',
    isApprove: 'true',
    address: '73 Elmwood St.Ponte Vedra Beach, FL 32082',
    logoImage:
      'https://amberstore.pk/uploads/307102714-img-20220911-wa0001.jpg',
    restuarantImage:
      'https://amberstore.pk/uploads/618652950-img-20220911-wa0000.jpg',
    role: 'Restaurant',
    isFeatured: false,
    category: 'Bbq',
    pickup: true,
    delivery: true,
    latitude: '24.8791027',
    longitude: '67.0363927',
    RequestedCategory: '',
  },
  {
    _id: '6311a048391e0a210b69fd85',
    name: 'Scarlett',
    destination: 'Paris, France',
    email: 'scarlett@gmail.com',
    gender: 'Female',
    phoneNumber: '123456789111',
    isApprove: 'true',
    age: 29,
    address: '169 Poplar Drive Poughkeepsie, NY 12601',
    logoImage: 'https://amberstore.pk/uploads/685572354-dymq4jnwsae6oxe.jpg',
    restuarantImage: 'https://amberstore.pk/uploads/227282794-logo.jpg',
    role: 'Restaurant',
    isFeatured: false,
    category: 'afghani food',
    pickup: true,
    delivery: false,
    latitude: '24.8703',
    longitude: '67.3682',
    RequestedCategory: '',
  },
  {
    _id: '6311a060391e0a210b69fd8b',
    name: 'Carter',
    email: 'carter@gmail.com',
    phoneNumber: '123456789111',
    isApprove: 'true',
    age: 28,
    destination: 'The Amazon Rainforest, Brazil',
    address: '932 Thorne St. El Dorado, AR 71730',
    logoImage: 'https://amberstore.pk/uploads/257095554-fastfood.jpg',
    restuarantImage: 'https://amberstore.pk/uploads/828448716-fastfood.jpg',
    gender: 'Male',
    role: 'Restaurant',
    isFeatured: false,
    category: '',
    pickup: true,
    delivery: false,
    latitude: '24.8703',
    longitude: '67.3682',
    RequestedCategory: '',
  },
  {
    _id: '632992a7ad438b85735a79ea',
    name: 'Hazel',
    email: 'hazel@gmail.com',
    age: 27,
    phoneNumber: '123456789111',
    destination: 'Santorini, Greece',
    isApprove: 'true',
    gender: 'Female',
    address: '589 Snake Hill St. Largo, FL 33771',
    logoImage: 'https://amberstore.pk/uploads/176155864-restaurant.jpg',
    restuarantImage: 'https://amberstore.pk/uploads/382516772-restaurant2.png',
    role: 'Restaurant',
    isFeatured: false,
    category: 'Bbq',
    pickup: false,
    age: 32,
    delivery: true,
    latitude: '24.8840604',
    longitude: '67.034556',
    RequestedCategory: '',
  },
  {
    _id: '632b6f379231e3c5712c9aa7',
    name: 'Hudson',
    email: 'hudsonhotmail.com',
    phoneNumber: '123456789111',
    isApprove: 'Deleted',
    gender: 'Male',
    destination: 'Bali, Indonesia',
    address: '933 Vernon St. Long Beach, NY 11561',
    age: 34,
    logoImage:
      'https://amberstore.pk/uploads/807485081-img-20220922-wa0001.jpeg',
    restuarantImage:
      'https://amberstore.pk/uploads/441494742-img-20220921-wa0102.jpg',
    role: 'Restaurant',
    isFeatured: false,
    category: 'Bbq',
    pickup: true,
    delivery: true,
    latitude: '24.8790971',
    longitude: '67.0373368',
    RequestedCategory: '',
  },
  {
    _id: '6333610e17c2b3d523775f65',
    name: 'Willow',
    email: 'willow@gmail.com',
    phoneNumber: '123456789111',
    isApprove: 'false',
    age: 31,
    gender: 'Male',
    address: '7131 Pineknoll Drive Bridgeton, NJ 08302',
    destination: 'Bora Bora, French Polynesia',
    logoImage:
      'https://amberstore.pk/uploads/728563192-img-20220928-wa0013.jpg',
    restuarantImage:
      'https://amberstore.pk/uploads/900630007-img-20220928-wa0013.jpg',
    role: 'Restaurant',
    isFeatured: false,
    category: 'Bbq',
    pickup: false,
    delivery: true,
    latitude: '24.8791029',
    longitude: '67.0363792',
    RequestedCategory: '',
  },
  {
    _id: '6334c11d17c2b3d523776178',
    name: 'Madison',
    email: 'madison@gmail.com',
    gender: 'Female',
    phoneNumber: '123456789111',
    age: 37,
    destination: 'New York City, USA',
    isApprove: 'Active',
    address: '1800 Ellis St, San Francisco, CA 94115, USA',
    logoImage:
      'https://amberstore.pk/uploads/182028438-08a60f38-edb5-41d0-bec1-bced8caeb7ae.jpg',
    restuarantImage:
      'https://amberstore.pk/uploads/139903997-3abe924f-efa9-48a2-a4bd-bc9130f05a5c.jpg',
    role: 'Restaurant',
    isFeatured: false,
    category: 'Bbq',
    pickup: false,
    delivery: true,
    latitude: '37.785834',
    longitude: '-122.406417',
    RequestedCategory: '',
  },
];

const displayRows = [
  'image',
  'name',
  'userName',
  'email',
  'phoneNumber',
  'gender',
  'city',
  'status',
];

const Customers = () => {
  const classes = restaurantStyle();
  const navigate = useNavigate();
  const [type, setType] = useState('add');
  const [openDialog, setOpenDialog] = useState(false);
  const [status, setStatus] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [inputValue, setInputValue] = useState({
    name: '',
    email: '',
    phoneNumber: '',
    address: '',
    status: '',
  });

  const [image, setImage] = useState('');
  const [category, setCategory] = useState('');
  const [allUsers, setAllUsers] = useState([]);
  const [snackbarProps, setSnackbarProps] = useState({
    open: false,
    type: '',
    message: '',
  });
  const [filerValue, setFilerValue] = useState('');
  const [focus, setFocus] = useState(null);
  const [dateValues, setDateValues] = useState({
    startDate: null,
    endDate: null,
  });

  const handleSnackbarVal = (open, type, message) => {
    setSnackbarProps({
      open,
      type,
      message,
    });
  };

  const handleOnDateChange = (startDate, endDate) => {
    let start = startDate.startDate;
    let end = startDate.endDate;
    setDateValues({
      startDate: start,
      endDate: end,
    });
  };

  const getData = () => {
    setIsLoading(true);
    getAllUsers()
      .then((response) => {
        setIsLoading(false);
        console.log('response', response);
        setAllUsers(response.data.data.reverse());
      })
      .catch((error) => {
        console.log(error, 'asdlskdjslkjdlk');
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getData();
  }, []);

  const handleEditStatus = (e, row, type) => {
    e.stopPropagation();
    let approveParam = {
      status: row.status == 'InActive' ? 'Active' : 'InActive',
      id: row._id,
    };
    setIsLoading(true);
    updateUserStatus(approveParam)
      .then((res) => {
        getData();
        handleSnackbarVal(true, "success", res?.data?.message);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        handleSnackbarVal(true, "error", err?.response?.data?.message);
      });
  };

  const handleClose = () => {
    setOpenDialog(false);
    setInputValue({
      name: '',
      email: '',
      phoneNumber: '',
      address: '',
    });
    setImage('');
    setCategory('');
  };

  // const handleDelete = (val) => {};

  const navigateToDetail = (row) => {
    navigate(`/restaurantDetail/${row.orderId}`, {
      state: row,
    });
  };

  const handleCloseSnackbar = () => {
    handleSnackbarVal(false, '', '');
  };

  const handleUpdateRequestedCat = (row, type) => {
    let params = {
      requestedCategory: row.RequestedCategory,
      restId: row._id,
    };

    let payload = {
      restId: row._id,
    };

    if (type === 'accept') {
      setIsLoading(true);
      updateCategoryStatus(params)
        .then((res) => {
          getData();
          setIsLoading(false);
          handleSnackbarVal(true, 'success', res?.data?.message);
        })
        .catch((err) => {
          setIsLoading(false);
          handleSnackbarVal(true, 'error', err?.response?.data?.message);
        });
    } else {
      setIsLoading(true);
      updateCategoryStatusRejected(payload)
        .then((res) => {
          getData();
          setIsLoading(false);
          handleSnackbarVal(true, 'success', res?.data?.message);
        })
        .catch((err) => {
          setIsLoading(false);
          handleSnackbarVal(true, 'error', err?.response?.data?.message);
        });
    }
  };

  const handleChangeFilter = (e) => {
    setFilerValue(e.target.value);
  };
  

  return (
    <NavigationDrawer>
      <Loader isloading={isLoading} />
      <SnackbarAlert
        snackbarProps={snackbarProps}
        handleCloseSnackbar={handleCloseSnackbar}
      />
      <Grid container alignItems='center' marginBottom={3}>
        <Grid item xs={12} md={2}>
          <Typography style={{ fontSize: '22px', fontWeight: '600' }}>
            Customers
          </Typography>
        </Grid>
      </Grid>

      <div
        style={{
          textAlign: 'right',
          margin: '20px 0',
          display: 'flex',
          justifyContent: 'flex-end',
        }}
      >
        <DateRangePicker
          isOutsideRange={() => false}
          startDatePlaceholderText='Start Date'
          startDate={dateValues.startDate}
          onDatesChange={handleOnDateChange}
          endDatePlaceholderText='End Date'
          endDate={dateValues.endDate}
          numberOfMonths={2}
          displayFormat='DD-MM-YYYY'
          showClearDates={true}
          focusedInput={focus}
          onFocusChange={(focus) => setFocus(focus)}
          startDateId='startDateMookh'
          endDateId='endDateMookh'
          minimumNights={0}
          small
          showDefaultInputIcon={false}
        />

        <FormControl size='small' style={{ width: '20%', margin: '0 10px' }}>
          <Select displayEmpty value={filerValue} onChange={handleChangeFilter}>
            <MenuItem value=''>Select Filter</MenuItem>
            <MenuItem value='Name'>Name</MenuItem>
            <MenuItem value='Email'>Email</MenuItem>
            <MenuItem value='male'>Male</MenuItem>
            <MenuItem value='female'>Female</MenuItem>
            <MenuItem value='city'>City</MenuItem>
          </Select>
        </FormControl>
        <TextField placeholder='Search' size='small' />
      </div>

      <DynamicTable
        headerData={headerData}
        bodyRows={allUsers}
        displayData={displayRows}
        showDelete={false}
        showEdit={false}
        // handleDelete={handleDelete}
        // openEditDialog={handleEditStatus}
        handleEditStatus={handleEditStatus}
        type={type}
        navigateToDetail={navigateToDetail}
        showSwitch={true}
        handleUpdateRequestedCat={handleUpdateRequestedCat}
      />

      <RestaurentDialog
        open={openDialog}
        setOpenDialog={setOpenDialog}
        type={type}
        handleClose={handleClose}
        inputValue={inputValue}
        setInputValue={setInputValue}
        image={image}
        setImage={setImage}
        category={category}
        setCategory={setCategory}
        setStatus={setStatus}
        status={status}
      />
    </NavigationDrawer>
  );
};

export default Customers;
